export const environment = {
  production: true,
  config: {
    baseUrl: 'https://master-7rqtwti-lofgzy3ea3siu.eu-5.platformsh.site',
  },
};
